import { IPicture } from '@api/models/image/picture';
import { CameraManufacturer } from '../cameras/cameras';
import { StreamCancelReason } from '../../http/events/dto/event-streaming-info.dto';

export enum LivestreamStatus {
  None = 'none',
  Upcoming = 'upcoming',
  Cancelled = 'cancelled',
  Live = 'live',
  Stopped = 'stopped',
  Ended = 'ended',
  Replay = 'replay',
  Highlights = 'highlights',
}

export const LivestreamStatusStringMap = new Map<LivestreamStatus, string>([
  [LivestreamStatus.None, 'Kein Status'],
  [LivestreamStatus.Upcoming, 'Geplant'],
  [LivestreamStatus.Live, 'Live'],
  [LivestreamStatus.Ended, 'Beendet'],
  [LivestreamStatus.Replay, 'Beendet'],
  [LivestreamStatus.Highlights, 'Beendet'],
  [LivestreamStatus.Cancelled, 'Abgesagt'],
  [LivestreamStatus.Stopped, 'Abgebrochen'],
]);

export interface IStreamingInfo {
  embed_code: string;
  embed_html: string;
  hls_url: string;
  live_status: LivestreamStatus;
  yt_url?: string;
  paywall?: boolean;
  livestream_preview?: IPicture;
  staige_id?: number;
  cameraid?: string;
  stream_source?: CameraManufacturer;
  manufacturer?: CameraManufacturer;
  camera_status?: any;
  reason?: StreamCancelReason | string;
  note?: string;
  live_commentary?: boolean;
  auto_cancel?: boolean;
  promo_code?: string;
}
